import { render, staticRenderFns } from "./Coordinator.vue?vue&type=template&id=6f73d99e&scoped=true&"
import script from "./Coordinator.vue?vue&type=script&lang=ts&"
export * from "./Coordinator.vue?vue&type=script&lang=ts&"
import style0 from "./Coordinator.vue?vue&type=style&index=0&id=6f73d99e&lang=scss&scoped=true&"
import style1 from "./Coordinator.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73d99e",
  null
  
)

export default component.exports